/**
 * Get grid column classes based on card type
 */
export function getGridColumns(cardType?: string): string {
  switch (cardType) {
    case 'benefitsCard':
      return 'grid-cols-1 sm:grid-cols-2 gap-card-layout-mobile xl:gap-card-layout-desktop md:grid xl:grid-cols-4';
    case 'highlightsCard':
      return 'grid-cols-1 sm:grid-cols-2 gap-card-layout-mobile xl:gap-card-layout-desktop md:grid lg:grid-cols-3';
    case 'featuresCards':
      return 'gap-card-layout-mobile xl:gap-card-layout-desktop md:flex md:flex-wrap md:justify-center content-center';
    default:
      return 'grid-cols-2 gap-card-layout-mobile xl:gap-card-layout-desktop md:grid lg:grid-cols-3';
  }
}
export function getCardItemClass(
  cardType?: string,
  cardCount = 0
): string {
  if (cardType === 'featuresCards') {
    if (cardCount === 5) {
      return 'w-full md:w-card-feature-md-2col lg:w-card-feature-lg-3col xl:w-card-feature-xl-3col';
    }
    return 'w-full md:w-card-feature-md-2col lg:w-card-feature-lg-4col xl:w-card-feature-xl-4col';
  }
  return '';
}

/**
 * Get carousel alignment based on card type
 */
export function getCarouselAlign(cardType?: string): 'start' | 'center' {
  if (cardType === 'features' || cardType === 'iconCard') return 'start';
  return 'center';
}

/**
 * Get carousel item classes based on card type
 */
export function getCarouselItemClass(cardType?: string): string {
  if (cardType === 'features')
    return 'pl-card-section-pl-mobile xl:pl-card-section-pl-desktop';
  if (cardType === 'iconCard')
    return 'basis-4/5 pl-card-section-pl-mobile xl:pl-card-section-pl-desktop';
  return 'py-4 pl-card-section-pl-mobile xl:pl-card-section-pl-desktop';
}

/**
 * Determine if card type should have peek/anschnitt on mobile
 */
export function shouldHavePeek(cardType?: string): boolean {
  return cardType === 'iconCard';
}

/**
 * Get carousel content classes based on card type
 */
export function getCarouselContentClass(cardType?: string): string {
  if (cardType === 'features')
    return 'p-2 ml-card-section-ml-mobile xl:ml-card-section-ml-desktop';
  if (cardType === 'iconCard')
    return 'ml-card-section-ml-mobile xl:ml-card-section-ml-desktop';
  return 'ml-card-section-ml-mobile xl:ml-card-section-ml-desktop';
}

/**
 * Determine if mobile carousel should be used based on card type
 */
export function shouldUseMobileCarousel(cardType?: string): boolean {
  switch (cardType) {
    case 'benefitsCard':
    case 'highlightsCard':
      return false;
    default:
      return true;
  }
}
